<template>
  <div style="display:inline-block">
    <v-tooltip bottom :color="color">
      <template v-slot:activator="{ on }">
        <span v-on="on">
          <slot></slot>
        </span>
      </template>
      <span>{{ label }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'Thetooltip',
  data: () => ({
    on: false,
  }),
  props: {
    label: String,
    color: { type: String, default: 'primary' },
  },
}
</script>

<style></style>
